import './App.css'
import GamePlay from './components/GamePlay'

const App = () => <GamePlay />

export default App
